import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

interface Props {
    leftText?: string;
    rightText?: string;
    checked?: boolean;
    setChecked?: (v: boolean) => void;
    canDisabled?: boolean;
}

function Switch({
    leftText, rightText, checked, setChecked, canDisabled,
}:Props) {
    const isDisabled = canDisabled && (!checked);
    return (
        <Row spacing={8}>
            {leftText && (
                <Text color={colors.gray7}
                    fontWeight={checked ? 'regular' : 'bold'}
                >
                    {leftText}
                </Text>
            )}
            <Container isDisabled={isDisabled}
                isChecked={checked}
                onClick={() => setChecked?.(!checked)}>
                <Handle isDisabled={isDisabled}
                    isChecked={checked} />
            </Container>
            {rightText && (
                <Text color={colors.gray7}
                    fontWeight={checked ? 'bold' : 'regular'}
                >
                    {rightText}
                </Text>
            )}
        </Row>
    );
}

const Container = styled.div<{
    isDisabled?: boolean;
    isChecked?: boolean;
}>`
    background-color: var(--color-gray2);
    border-radius: 12px;
    height: 24px;
    width: 46px;
    display: flex;
    align-items: center;
    transition: 100ms;
    ${({ isDisabled }) => isDisabled && css`
        background-color: rgba(175, 168, 165, 0.35);
    `}
    ${({ isChecked }) => isChecked && css`
        background-color: var(--color-secondary);
    `}
`;

const Handle = styled.div<{
    isDisabled?: boolean;
    isChecked?: boolean;
}>`
    border-radius: 12px;
    transition: 100ms;
    width: 20px;
    height: 20px;
    margin-left: 2px;
    background-color: var(--color-gray4);
    ${({ isDisabled }) => isDisabled && css`
        background-color: #AFA8A5;
    `}
    ${({ isChecked }) => isChecked && css`
        width: 24px;
        height: 24px;
        background-color: var(--color-primary);
        transform: translateX(20px);
    `}
`;

export default Switch;
